<div class="row no-gutters mt-3">
  <div class="col">
    <h4>Tools</h4>
  </div>
</div>

<app-crud-list [observabledata]="getObservableData()"
               [postTreatmentCallback]="getPostTreatmentCallback()"
               [listEditPathCallback]="getListEditPathCallback()"
               [displayedColumns]="displayedcolumns"
               [idColumnName]="'id'"
               [creatable]="false"
               [entityroot]="entityroot"
               [deleteEntityHandler]="deleteEntityHandler()"
               [removePostTreatmentHandler]="deletePostTreatmentHandler()"
>
</app-crud-list>
